import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { format } from "date-fns";
import type { WorkSearchResult } from "@/pages/calendarWorkSearch";

export function CalendarWorkFinder({ query, selectedId, modeLabel, results, loading, error, onQuery, onClear, onChoose }: {
  query: string; selectedId: number | null; modeLabel: string; results: WorkSearchResult[];
  loading: boolean; error: boolean; onQuery: (query: string) => void; onClear: () => void;
  onChoose: (id: number, date: Date) => void;
}) {
  const active = !!query.trim() || selectedId !== null;
  return (
    <section className="min-w-0 shrink-0 space-y-2 rounded-lg border bg-card p-3" aria-label="Buscar obra en el calendario">
      <div className="flex flex-wrap items-center gap-2">
        <label className="min-w-0 flex-1 space-y-1 text-sm font-medium">
          Buscar obra
          <Input type="search" maxLength={200} value={query} onChange={event => onQuery(event.target.value)}
            placeholder="Nombre, código o cliente" />
        </label>
        {active && <Button variant="outline" size="sm" onClick={onClear}>Ver todas las obras</Button>}
      </div>
      <p className="text-xs text-muted-foreground">{modeLabel}: búsqueda en todos los periodos disponibles con los filtros actuales. Elige el periodo al que quieres ir.</p>
      {active && <div aria-live="polite" className="max-h-72 space-y-2 overflow-y-auto">
        {loading ? <p className="text-sm">Cargando periodos…</p>
          : error ? <p role="alert" className="text-sm">No se pudieron cargar los periodos. Recarga antes de elegir una fecha.</p>
          : results.length === 0 ? <p className="text-sm">No hay obras coincidentes disponibles con estos filtros.</p>
          : results.map(work => <div key={work.id} className="min-w-0 space-y-1 rounded border p-2">
            <p className="break-words text-sm font-medium">{work.label}</p>
            {work.customer && <p className="break-words text-xs text-muted-foreground">{work.customer}</p>}
            {work.periods.length === 0 ? <p className="text-sm">Sin periodos en {modeLabel} con los filtros actuales.</p>
              : <ul className="space-y-1">{work.periods.map(period => <li key={period.key}>
                <Button variant={selectedId === work.id ? "secondary" : "outline"} size="sm"
                  className="h-auto max-w-full whitespace-normal text-left" onClick={() => onChoose(work.id, period.start)}>
                  Ir a {format(period.start, "dd/MM/yyyy")}{period.end ? ` – ${format(period.end, "dd/MM/yyyy")}` : " – en curso"} · {period.label}
                </Button>
              </li>)}</ul>}
          </div>)}
      </div>}
    </section>
  );
}
